import React, { type ReactElement } from 'react';
import { useController, ApplicationView } from '@aha-app/mvc';
import AssistantViewController, {
  type AttachmentStatus,
} from '../AssistantView/AssistantViewController';
import styles from './PromptPanel.module.css';

const AttachmentItem = ({
  attachmentStatus,
}: {
  attachmentStatus: AttachmentStatus;
}) => {
  const controller = useController(AssistantViewController);

  const onRemove = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    controller.actionDeleteAttachment(attachmentStatus);
  };

  const closeButton = (
    <div className={styles.attachmentClose} onClick={onRemove}>
      <i className='far fa-times' />
    </div>
  );

  if (attachmentStatus.loading) {
    return (
      <div className={styles.attachment} key={attachmentStatus.id}>
        {closeButton}
        <div className={styles.attachmentLoading}>
          <aha-spinner size='6ex' />
        </div>
      </div>
    );
  }

  const attachment = attachmentStatus.attachment!;
  const isImage = attachment.contentType?.startsWith('image/') ?? false;
  let content: ReactElement | null = null;

  if (isImage) {
    content = (
      <img
        className={styles.attachmentImage}
        src={attachment.downloadUrl}
        alt={attachment.fileName}
      />
    );
  } else {
    content = (
      <div className={styles.attachmentFile}>
        <i className='far fa-file-lines' />
        <span className={styles.scopeItemText}>{attachment.fileName}</span>
        <i className='fa fa-xmark' onClick={onRemove} />
      </div>
    );
  }

  return (
    <div
      className={styles.attachment}
      key={attachmentStatus.id}
      onClick={() => {
        controller.actionShowAttachment(attachment);
      }}
    >
      {isImage && closeButton}
      {content}
    </div>
  );
};

export default ApplicationView(AttachmentItem);
